// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from '../../gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import {
  EventItemFragmentDoc,
  ReceiptItemFragmentDoc,
  AnnotationItemFragmentDoc,
  LedgerCategoryInfoItemFragmentDoc,
} from '../../common-client-queries.generated';
export type AccountBalancesFragment = {
  readonly __typename: 'AccountsInfo';
  readonly accounts: ReadonlyArray<{
    readonly __typename: 'Account';
    readonly accountNumber: string;
    readonly balanceNok: {
      readonly __typename: 'AmountInfo';
      readonly asNumber: number;
    } | null;
  }>;
};

export type EventPageQueryVariables = Types.Exact<{
  incompleteOnly: Types.Scalars['Boolean'];
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  searchTerm?: Types.InputMaybe<Types.Scalars['String']>;
  includeIncompleteCount: Types.Scalars['Boolean'];
  searchId?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type EventPageQuery = {
  readonly __typename: 'Query';
  readonly events: {
    readonly __typename: 'EventPage';
    readonly incompleteCount: number | null;
    readonly earliestTimestampInPage: string | null;
    readonly combinedItems: ReadonlyArray<
      | {
          readonly __typename: 'Event';
          readonly fid: string;
          readonly dateTime: string;
          readonly movementType: Types.MovementType;
          readonly title: string;
          readonly description: string;
          readonly subtitle: string | null;
          readonly infoLine: string | null;
          readonly icon: string | null;
          readonly bulkPaymentFid: string | null;
          readonly currencyAmount: string | null;
          readonly currencyCode: string | null;
          readonly amount: string | null;
          readonly physicalTerminal: boolean;
          readonly isInvoice: boolean;
          readonly isOwnCardEvent: boolean;
          readonly completed: boolean;
          readonly isEditable: boolean;
          readonly card: {
            readonly __typename: 'Card';
            readonly fid: string;
            readonly name: string | null;
          } | null;
          readonly account: {
            readonly __typename: 'Account';
            readonly accountNumber: string;
            readonly name: string;
          } | null;
          readonly transaction: {
            readonly __typename: 'EventTransaction';
            readonly fid: string;
            readonly remittanceInformation: string | null;
            readonly debtorAccountNumber: string | null;
            readonly creditorAccountNumber: string | null;
            readonly kid: string | null;
            readonly bookingDate: string | null;
            readonly isPending: boolean;
          } | null;
          readonly payment: {
            readonly __typename: 'PaymentInfo';
            readonly paymentFid: string;
            readonly status: Types.PaymentStatus;
            readonly kid: string | null;
            readonly message: string | null;
            readonly debtorAccount: string;
            readonly creditorAccount: string;
            readonly isTaxPayment: boolean;
            readonly external: boolean;
            readonly fee: string | null;
            readonly createdBy: {
              readonly __typename: 'Agent';
              readonly fid: string;
              readonly structuredName: {
                readonly __typename: 'Name';
                readonly full: string;
                readonly first: string | null;
              };
            } | null;
            readonly signedBy: {
              readonly __typename: 'Agent';
              readonly fid: string;
              readonly structuredName: {
                readonly __typename: 'Name';
                readonly full: string;
                readonly first: string | null;
              };
            } | null;
            readonly accountingSystemInformation: {
              readonly __typename: 'AccountingSystemPaymentInformation';
              readonly systemName: string;
              readonly ledgerAccount: number | null;
              readonly externalURL: string | null;
            } | null;
          } | null;
          readonly merchant: {
            readonly __typename: 'Merchant';
            readonly fid: string;
            readonly name: string;
          } | null;
          readonly receipts: ReadonlyArray<{
            readonly __typename: 'Receipt';
            readonly fid: string;
            readonly mime: string;
            readonly uploadedAt: string;
            readonly userData: string | null;
            readonly isInvoice: boolean;
            readonly receiptLooksValid: boolean;
            readonly images: {
              readonly __typename: 'ReceiptImages';
              readonly color: string;
              readonly originalUrl: string;
              readonly croppedUrl: string | null;
              readonly thumbnail128Url: string | null;
              readonly thumbnail256Url: string | null;
              readonly thumbnail512Url: string | null;
            };
          }>;
          readonly note: {
            readonly __typename: 'Annotation';
            readonly fid: string;
            readonly dateTime: string;
            readonly text: string;
            readonly agentInfo: {
              readonly __typename: 'Agent';
              readonly fid: string;
              readonly structuredName: {
                readonly __typename: 'Name';
                readonly full: string;
                readonly first: string | null;
              };
            } | null;
          } | null;
          readonly purpose: {
            readonly __typename: 'Annotation';
            readonly fid: string;
            readonly dateTime: string;
            readonly text: string;
            readonly agentInfo: {
              readonly __typename: 'Agent';
              readonly fid: string;
              readonly structuredName: {
                readonly __typename: 'Name';
                readonly full: string;
                readonly first: string | null;
              };
            } | null;
          } | null;
          readonly participants: {
            readonly __typename: 'Annotation';
            readonly fid: string;
            readonly dateTime: string;
            readonly text: string;
            readonly agentInfo: {
              readonly __typename: 'Agent';
              readonly fid: string;
              readonly structuredName: {
                readonly __typename: 'Name';
                readonly full: string;
                readonly first: string | null;
              };
            } | null;
          } | null;
          readonly receiptNotNeeded: {
            readonly __typename: 'Annotation';
            readonly fid: string;
            readonly dateTime: string;
            readonly text: string;
            readonly agentInfo: {
              readonly __typename: 'Agent';
              readonly fid: string;
              readonly structuredName: {
                readonly __typename: 'Name';
                readonly full: string;
                readonly first: string | null;
              };
            } | null;
          } | null;
          readonly receiptLost: {
            readonly __typename: 'Annotation';
            readonly fid: string;
            readonly dateTime: string;
            readonly text: string;
            readonly agentInfo: {
              readonly __typename: 'Agent';
              readonly fid: string;
              readonly structuredName: {
                readonly __typename: 'Name';
                readonly full: string;
                readonly first: string | null;
              };
            } | null;
          } | null;
          readonly requirements: {
            readonly __typename: 'EventRequirements';
            readonly metRequirementCount: number;
            readonly totalRequirementCount: number;
            readonly allRequirementsMet: boolean;
            readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
            readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
            readonly requirementsOverridden: {
              readonly __typename: 'RequirementsOverriddenInfo';
              readonly overridden: boolean;
              readonly accountingSystem: string | null;
            };
          };
          readonly ledgerCategoryInfo: {
            readonly __typename: 'LedgerCategoryInfo';
            readonly kind: Types.LedgerCategoryInfoKind;
            readonly category: {
              readonly __typename: 'LedgerCategoryItem';
              readonly fid: string;
              readonly title: string;
              readonly subtitle: string | null;
              readonly icon: Types.LedgerCategoryIcon;
              readonly synonyms: ReadonlyArray<string>;
              readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
            } | null;
            readonly guesses: ReadonlyArray<{
              readonly __typename: 'LedgerCategoryItem';
              readonly fid: string;
            }>;
          };
        }
      | {
          readonly __typename: 'SalaryPayment';
          readonly fid: string;
          readonly dateTime: string;
          readonly salaryAmount: string;
          readonly debtorAccount: {
            readonly __typename: 'Account';
            readonly accountNumber: string;
            readonly name: string;
          };
          readonly payments: ReadonlyArray<{
            readonly __typename: 'PaymentInfo';
            readonly paymentFid: string;
            readonly creditorName: string;
            readonly creditorAccount: string;
            readonly isTaxPayment: boolean;
            readonly status: Types.PaymentStatus;
            readonly nokAmount: {
              readonly __typename: 'AmountInfo';
              readonly asAbsoluteNumber: number;
            };
          }>;
          readonly ledgerCategoryInfo: {
            readonly __typename: 'LedgerCategoryInfo';
            readonly kind: Types.LedgerCategoryInfoKind;
            readonly category: {
              readonly __typename: 'LedgerCategoryItem';
              readonly fid: string;
              readonly title: string;
              readonly subtitle: string | null;
              readonly icon: Types.LedgerCategoryIcon;
              readonly synonyms: ReadonlyArray<string>;
              readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
            } | null;
            readonly guesses: ReadonlyArray<{
              readonly __typename: 'LedgerCategoryItem';
              readonly fid: string;
            }>;
          };
          readonly accountingSystemInformation: {
            readonly __typename: 'AccountingSystemPaymentInformation';
            readonly externalURL: string | null;
          } | null;
        }
    >;
  };
  readonly accountsInfo: {
    readonly __typename: 'AccountsInfo';
    readonly accounts: ReadonlyArray<{
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    }>;
  };
};

export type SalaryEventItemFragment = {
  readonly __typename: 'SalaryPayment';
  readonly fid: string;
  readonly dateTime: string;
  readonly salaryAmount: string;
  readonly debtorAccount: {
    readonly __typename: 'Account';
    readonly accountNumber: string;
    readonly name: string;
  };
  readonly payments: ReadonlyArray<{
    readonly __typename: 'PaymentInfo';
    readonly paymentFid: string;
    readonly creditorName: string;
    readonly creditorAccount: string;
    readonly isTaxPayment: boolean;
    readonly status: Types.PaymentStatus;
    readonly nokAmount: {
      readonly __typename: 'AmountInfo';
      readonly asAbsoluteNumber: number;
    };
  }>;
  readonly ledgerCategoryInfo: {
    readonly __typename: 'LedgerCategoryInfo';
    readonly kind: Types.LedgerCategoryInfoKind;
    readonly category: {
      readonly __typename: 'LedgerCategoryItem';
      readonly fid: string;
      readonly title: string;
      readonly subtitle: string | null;
      readonly icon: Types.LedgerCategoryIcon;
      readonly synonyms: ReadonlyArray<string>;
      readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
    } | null;
    readonly guesses: ReadonlyArray<{
      readonly __typename: 'LedgerCategoryItem';
      readonly fid: string;
    }>;
  };
  readonly accountingSystemInformation: {
    readonly __typename: 'AccountingSystemPaymentInformation';
    readonly externalURL: string | null;
  } | null;
};

export type EmployeesListQueryVariables = Types.Exact<{ [key: string]: never }>;

export type EmployeesListQuery = {
  readonly __typename: 'Query';
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly employeesWithCards: ReadonlyArray<{
      readonly __typename: 'EmployeeWithCard';
      readonly agent: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
        };
      };
      readonly accounts: ReadonlyArray<{
        readonly __typename: 'Account';
        readonly accountNumber: string;
      }>;
    }>;
  };
};

export type CreateFoundingCompanyDocumentsMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CreateFoundingCompanyDocumentsMutation = {
  readonly __typename: 'Mutation';
  readonly createFoundingCompanyDocuments: {
    readonly __typename: 'OnboardingSignerUrl';
    readonly url: string;
  };
};

export type GetNewEventsAndBalanceQueryVariables = Types.Exact<{
  eventFids: ReadonlyArray<Types.Scalars['UUID']> | Types.Scalars['UUID'];
}>;

export type GetNewEventsAndBalanceQuery = {
  readonly __typename: 'Query';
  readonly eventsByFid: {
    readonly __typename: 'EventsByFids';
    readonly items: ReadonlyArray<{
      readonly __typename: 'Event';
      readonly fid: string;
      readonly dateTime: string;
      readonly movementType: Types.MovementType;
      readonly title: string;
      readonly description: string;
      readonly subtitle: string | null;
      readonly infoLine: string | null;
      readonly icon: string | null;
      readonly bulkPaymentFid: string | null;
      readonly currencyAmount: string | null;
      readonly currencyCode: string | null;
      readonly amount: string | null;
      readonly physicalTerminal: boolean;
      readonly isInvoice: boolean;
      readonly isOwnCardEvent: boolean;
      readonly completed: boolean;
      readonly isEditable: boolean;
      readonly card: {
        readonly __typename: 'Card';
        readonly fid: string;
        readonly name: string | null;
      } | null;
      readonly account: {
        readonly __typename: 'Account';
        readonly accountNumber: string;
        readonly name: string;
      } | null;
      readonly transaction: {
        readonly __typename: 'EventTransaction';
        readonly fid: string;
        readonly remittanceInformation: string | null;
        readonly debtorAccountNumber: string | null;
        readonly creditorAccountNumber: string | null;
        readonly kid: string | null;
        readonly bookingDate: string | null;
        readonly isPending: boolean;
      } | null;
      readonly payment: {
        readonly __typename: 'PaymentInfo';
        readonly paymentFid: string;
        readonly status: Types.PaymentStatus;
        readonly kid: string | null;
        readonly message: string | null;
        readonly debtorAccount: string;
        readonly creditorAccount: string;
        readonly isTaxPayment: boolean;
        readonly external: boolean;
        readonly fee: string | null;
        readonly createdBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly signedBy: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
        readonly accountingSystemInformation: {
          readonly __typename: 'AccountingSystemPaymentInformation';
          readonly systemName: string;
          readonly ledgerAccount: number | null;
          readonly externalURL: string | null;
        } | null;
      } | null;
      readonly merchant: {
        readonly __typename: 'Merchant';
        readonly fid: string;
        readonly name: string;
      } | null;
      readonly receipts: ReadonlyArray<{
        readonly __typename: 'Receipt';
        readonly fid: string;
        readonly mime: string;
        readonly uploadedAt: string;
        readonly userData: string | null;
        readonly isInvoice: boolean;
        readonly receiptLooksValid: boolean;
        readonly images: {
          readonly __typename: 'ReceiptImages';
          readonly color: string;
          readonly originalUrl: string;
          readonly croppedUrl: string | null;
          readonly thumbnail128Url: string | null;
          readonly thumbnail256Url: string | null;
          readonly thumbnail512Url: string | null;
        };
      }>;
      readonly note: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly purpose: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly participants: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptNotNeeded: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly receiptLost: {
        readonly __typename: 'Annotation';
        readonly fid: string;
        readonly dateTime: string;
        readonly text: string;
        readonly agentInfo: {
          readonly __typename: 'Agent';
          readonly fid: string;
          readonly structuredName: {
            readonly __typename: 'Name';
            readonly full: string;
            readonly first: string | null;
          };
        } | null;
      } | null;
      readonly requirements: {
        readonly __typename: 'EventRequirements';
        readonly metRequirementCount: number;
        readonly totalRequirementCount: number;
        readonly allRequirementsMet: boolean;
        readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
        readonly requirementsOverridden: {
          readonly __typename: 'RequirementsOverriddenInfo';
          readonly overridden: boolean;
          readonly accountingSystem: string | null;
        };
      };
      readonly ledgerCategoryInfo: {
        readonly __typename: 'LedgerCategoryInfo';
        readonly kind: Types.LedgerCategoryInfoKind;
        readonly category: {
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
          readonly title: string;
          readonly subtitle: string | null;
          readonly icon: Types.LedgerCategoryIcon;
          readonly synonyms: ReadonlyArray<string>;
          readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
        } | null;
        readonly guesses: ReadonlyArray<{
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
        }>;
      };
    }>;
    readonly salaryItems: ReadonlyArray<{
      readonly __typename: 'SalaryPayment';
      readonly fid: string;
      readonly dateTime: string;
      readonly salaryAmount: string;
      readonly debtorAccount: {
        readonly __typename: 'Account';
        readonly accountNumber: string;
        readonly name: string;
      };
      readonly payments: ReadonlyArray<{
        readonly __typename: 'PaymentInfo';
        readonly paymentFid: string;
        readonly creditorName: string;
        readonly creditorAccount: string;
        readonly isTaxPayment: boolean;
        readonly status: Types.PaymentStatus;
        readonly nokAmount: {
          readonly __typename: 'AmountInfo';
          readonly asAbsoluteNumber: number;
        };
      }>;
      readonly ledgerCategoryInfo: {
        readonly __typename: 'LedgerCategoryInfo';
        readonly kind: Types.LedgerCategoryInfoKind;
        readonly category: {
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
          readonly title: string;
          readonly subtitle: string | null;
          readonly icon: Types.LedgerCategoryIcon;
          readonly synonyms: ReadonlyArray<string>;
          readonly requirements: ReadonlyArray<Types.LedgerCategoryItemRequirement>;
        } | null;
        readonly guesses: ReadonlyArray<{
          readonly __typename: 'LedgerCategoryItem';
          readonly fid: string;
        }>;
      };
      readonly accountingSystemInformation: {
        readonly __typename: 'AccountingSystemPaymentInformation';
        readonly externalURL: string | null;
      } | null;
    }>;
  };
  readonly accountsInfo: {
    readonly __typename: 'AccountsInfo';
    readonly accounts: ReadonlyArray<{
      readonly __typename: 'Account';
      readonly accountNumber: string;
      readonly balanceNok: {
        readonly __typename: 'AmountInfo';
        readonly asNumber: number;
      } | null;
    }>;
  };
};

export const AccountBalancesFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AccountBalances' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'AccountsInfo' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'balanceNok' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asNumber' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccountBalancesFragment, unknown>;
export const SalaryEventItemFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SalaryEventItem' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'SalaryPayment' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'dateTime' },
            name: { kind: 'Name', value: 'executionDate' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'debtorAccount' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountNumber' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'paymentFid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nokAmount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asAbsoluteNumber' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditorName' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creditorAccount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isTaxPayment' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ledgerCategoryInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'LedgerCategoryInfoItem' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountingSystemInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'externalURL' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'salaryAmount' },
            name: { kind: 'Name', value: 'amount' },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SalaryEventItemFragment, unknown>;
export const EventPageDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventPage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'incompleteOnly' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'before' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchTerm' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'includeIncompleteCount' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'searchId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'events' },
            name: { kind: 'Name', value: 'eventPage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'incompleteOnly' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'incompleteOnly' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'before' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchTerm' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchTerm' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeIncompleteCount' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'includeIncompleteCount' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'searchId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'incompleteCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'earliestTimestampInPage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'combinedItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'Event' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'EventItem' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SalaryPayment' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'SalaryEventItem' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountsInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AccountBalances' },
                },
              ],
            },
          },
        ],
      },
    },
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
    ...SalaryEventItemFragmentDoc.definitions,
    ...AccountBalancesFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<EventPageQuery, EventPageQueryVariables>;
export const EmployeesListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EmployeesList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employeesWithCards' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'structuredName' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'full' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'first' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accounts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accountNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EmployeesListQuery, EmployeesListQueryVariables>;
export const CreateFoundingCompanyDocumentsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateFoundingCompanyDocuments' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFoundingCompanyDocuments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateFoundingCompanyDocumentsMutation,
  CreateFoundingCompanyDocumentsMutationVariables
>;
export const GetNewEventsAndBalanceDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetNewEventsAndBalance' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'eventFids' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UUID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventsByFid' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventFids' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'eventFids' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'EventItem' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'salaryItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SalaryEventItem' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountsInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'AccountBalances' },
                },
              ],
            },
          },
        ],
      },
    },
    ...EventItemFragmentDoc.definitions,
    ...ReceiptItemFragmentDoc.definitions,
    ...AnnotationItemFragmentDoc.definitions,
    ...LedgerCategoryInfoItemFragmentDoc.definitions,
    ...SalaryEventItemFragmentDoc.definitions,
    ...AccountBalancesFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<
  GetNewEventsAndBalanceQuery,
  GetNewEventsAndBalanceQueryVariables
>;
